import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import './Header.css';

const Header = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 100;
            setScrolled(isScrolled);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <Navbar 
            expand="lg" 
            className={`navbar-custom ${scrolled ? 'navbar-scrolled' : ''}`} 
            fixed="top"
        >
            <Container>
                <Navbar.Brand href="#home" className="d-flex align-items-center">
                    <div className="logo-icon me-2">
                        <i className="fas fa-tooth"></i>
                    </div>
                    <div>
                        <div className="brand-name">DentalCare</div>
                        <div className="brand-subtitle">Excellence & Innovation</div>
                    </div>
                </Navbar.Brand>
                
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto align-items-center">
                        <Nav.Link href="#home" className="nav-link-custom">Accueil</Nav.Link>
                        <Nav.Link href="#services" className="nav-link-custom">Services</Nav.Link>
                        <Nav.Link href="#about" className="nav-link-custom">À Propos</Nav.Link>
                        <Nav.Link href="#team" className="nav-link-custom">Équipe</Nav.Link>
                        <Nav.Link href="#gallery" className="nav-link-custom">Galerie</Nav.Link>
                        <Nav.Link href="#contact" className="nav-link-custom">Contact</Nav.Link>
                        <Button className="btn-appointment ms-3">
                            <i className="fas fa-calendar-plus me-2"></i>
                            Rendez-vous
                        </Button>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;